export default __webpack_public_path__ + "static/media/p-card.e3e2eb06.png";